import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, Filter } from 'lucide-react';
import './Gallery.css';

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const categories = ['All', 'Interior Design', 'Furniture', 'Kitchen', 'Commercial'];

  const galleryImages = [
    {
      src: '/images/Custom Interior Lighting.jpg',
      title: 'Custom Interior Lighting',
      category: 'Interior Design'
    },
    {
      src: '/images/Table and Chairs.jpg',
      title: 'Dining Table & Chairs',
      category: 'Furniture'
    },
    {
      src: '/images/Table Tennis Court Interior.jpg',
      title: 'Table Tennis Court Interior',
      category: 'Commercial'
    },
    {
      src: '/images/Hotel and Restaurant Interior Design 1.jpg',
      title: 'Hotel & Restaurant Interior',
      category: 'Commercial'
    },
    {
      src: '/images/Hotel Lobby Interior Design.jpg',
      title: 'Hotel Lobby Design',
      category: 'Commercial'
    },
    {
      src: '/images/Kitchen Drawers.jpg',
      title: 'Modular Kitchen Drawers',
      category: 'Kitchen'
    },
    {
      src: '/images/livingroom2.jpg',
      title: 'Modern Living Room',
      category: 'Interior Design'
    },
    {
      src: '/images/jmjbeds.jpg',
      title: 'Custom Bedroom Design',
      category: 'Furniture'
    },
    {
      src: '/images/s2naalukett.jpg',
      title: 'Traditional Kerala Interior',
      category: 'Interior Design'
    },
    {
      src: '/images/s2.jpg',
      title: 'Modern Home Interior',
      category: 'Interior Design'
    },
    {
      src: '/images/sitout.jpg',
      title: 'Outdoor Sitting Area',
      category: 'Interior Design'
    },
    {
      src: '/images/terrace.jpg',
      title: 'Terrace Design',
      category: 'Interior Design'
    }
  ];

  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % filteredImages.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(filteredImages[nextIndex]);
  };

  const prevImage = () => {
    const prevIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(filteredImages[prevIndex]);
  };

  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="gallery-hero-content"
          >
            <h1 className="font-display">Our Portfolio</h1>
            <p>
              Explore our stunning collection of interior design projects, custom furniture, 
              and architectural transformations across Kerala.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="gallery-filters">
            <Filter size={20} />
            <span>Filter by:</span>
            {categories.map((category) => (
              <button
                key={category}
                className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          <motion.div
            layout
            className="gallery-masonry"
          >
            {filteredImages.map((image, index) => (
              <motion.div
                key={`${image.src}-${selectedCategory}`}
                layout
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.4 }}
                className="gallery-masonry-item"
                onClick={() => openLightbox(image, index)}
              >
                <img src={image.src} alt={image.title} />
                <div className="gallery-masonry-overlay">
                  <div className="gallery-masonry-info">
                    <h3>{image.title}</h3>
                    <p>{image.category}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>

          {filteredImages.length === 0 && (
            <div className="no-results">
              <p>No images found for the selected category.</p>
            </div>
          )}

          {selectedImage && (
            <div className="lightbox" onClick={closeLightbox}>
              <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="lightbox-close" onClick={closeLightbox}>
                  <X size={24} />
                </button>
                <button className="lightbox-prev" onClick={prevImage}>
                  <ChevronLeft size={24} />
                </button>
                <button className="lightbox-next" onClick={nextImage}>
                  <ChevronRight size={24} />
                </button>
                <img src={selectedImage.src} alt={selectedImage.title} />
                <div className="lightbox-info">
                  <h3>{selectedImage.title}</h3>
                  <p>{selectedImage.category}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Gallery;